import * as React from 'react'
import { useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import PasswordConditions from './PasswordConditions'
import * as S from './PasswordForm.styles'

const PasswordForm: React.FC<PasswordFormProps> = ({
  errorMessage = '',
  errorMessage2 = '',
  newPassword = false,
  withMarginY = false
}) => {
  const [password, setPassword] = React.useState('')
  const [password2, setPassword2] = React.useState('')
  const [isPassShown, setIsPassShown] = React.useState(false)
  const [isPassShown2, setIsPassShown2] = React.useState(false)
  const [isFocused, setIsFocused] = React.useState(false)
  const [isFocused2, setIsFocused2] = React.useState(false)
  const [hasBlurredOnce, setHasBlurredOnce] = React.useState(false)
  const [hasBlurredOnce2, setHasBlurredOnce2] = React.useState(false)
  const [isAllPassed, setIsAllPassed] = React.useState(false)
  const [serverErrorMessage, setServerErrorMessage] =
    React.useState(errorMessage)
  const [serverErrorMessage2, setServerErrorMessage2] =
    React.useState(errorMessage2)

  const { t } = useTranslation()

  const hasAllPassed = (passed: boolean) => setIsAllPassed(passed)

  React.useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('laced_password_form_valid', { detail: isAllPassed })
    )
  }, [isAllPassed])

  const passwordConfirmationError = (
    <S.ConfirmationError className="footnote">
      {t('react_components.passwords.no_match')}
    </S.ConfirmationError>
  )

  return (
    <S.FormContainer marginY={withMarginY}>
      <S.InputContainerLabel active={isFocused} htmlFor="Password">
        <S.InputContainerLabelText className="caption">
          {newPassword
            ? t('react_components.passwords.new_password')
            : t('react_components.passwords.password')}
          {hasBlurredOnce && !isAllPassed && password && ' *'}
        </S.InputContainerLabelText>
        <S.InputContainer
          error={
            (hasBlurredOnce && !isAllPassed && !!password) ||
            !!serverErrorMessage
          }
        >
          <input
            className="footnote"
            type={isPassShown ? 'text' : 'password'}
            onChange={(e) => {
              setPassword(e.target.value)
              setServerErrorMessage('')
            }}
            onBlur={() => {
              setHasBlurredOnce(true)
              setIsFocused(false)
            }}
            onFocus={() => setIsFocused(true)}
            name="user[password]"
            id="Password"
            spellCheck="false"
            maxLength={50}
          />
          <S.VisibilityToggleButton
            type="button"
            className="footnote"
            onClick={() => {
              setIsPassShown(!isPassShown)
            }}
          >
            {t(`shared.${isPassShown ? 'hide' : 'show'}`)}
          </S.VisibilityToggleButton>
        </S.InputContainer>
      </S.InputContainerLabel>

      <PasswordConditions
        password={password}
        focused={isFocused}
        hasAllPassed={hasAllPassed}
        errorMessage={serverErrorMessage}
      />

      <S.InputContainerLabel active={isFocused2} htmlFor="pass2">
        <S.InputContainerLabelText className="caption">
          {newPassword
            ? t('react_components.passwords.re_enter_new_password')
            : t('react_components.passwords.re_enter_password')}
        </S.InputContainerLabelText>
        <S.InputContainer
          error={
            (hasBlurredOnce2 && password !== password2) || !!serverErrorMessage2
          }
        >
          <input
            type={isPassShown2 ? 'text' : 'password'}
            className="footnote"
            onChange={(e) => {
              setServerErrorMessage2('')
              setPassword2(e.target.value)
            }}
            onBlur={() => {
              setHasBlurredOnce2(true)
              setIsFocused2(false)
            }}
            onFocus={() => setIsFocused2(true)}
            id="Password confirmation"
            name="user[password_confirmation]"
            spellCheck="false"
            maxLength={50}
          />
          <S.VisibilityToggleButton
            type="button"
            className="footnote"
            onClick={() => {
              setIsPassShown2(!isPassShown2)
            }}
          >
            {t(`shared.${isPassShown2 ? 'hide' : 'show'}`)}
          </S.VisibilityToggleButton>
        </S.InputContainer>
      </S.InputContainerLabel>
      {serverErrorMessage2
        ? passwordConfirmationError
        : hasBlurredOnce2 &&
          password !== password2 &&
          !isFocused2 &&
          passwordConfirmationError}
    </S.FormContainer>
  )
}

export default withTranslations(PasswordForm)

interface PasswordFormProps {
  errorMessage?: string
  errorMessage2?: string
  newPassword?: boolean
  withMarginY?: boolean
}
